import { DisabledModelParts } from '@/components/Editor/types/editor';

export const isMeshWithSizeData = (meshName: string): boolean => {
  return meshName.includes(DisabledModelParts.size);
};
